import InputTypesEnum from "../../../Enums/InputTypesEnum";
import IobLineItemSearchParams from "./IobLineItemSearchParams";

export default class IobLineItemFieldworkFeesSearchParams extends IobLineItemSearchParams {

    static fieldsInSearchBox = [
        { fieldName: "IoblineItemId", label: "Line Item ID", className: "col-4", type: InputTypesEnum.Text },
		{ fieldName: "Type", label: "Type", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getSelectValuesForType() },
		{ fieldName: "SelectedAssignmentCountries", label: "Assignment Country", className: "col-4", type: InputTypesEnum.CountryMultiChoice },
		{ fieldName: "SelectedStatuses", label: "Status", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getStatusValues() },
		{ fieldName: "AssignmentApolloId", label: "Apollo Assignment ID", className: "col-4", type: InputTypesEnum.Text },
    ];
}